/* kali-ambient.js — starfield + cursor comet, ported from ihatekali.com */
(function () {
  var canvas = document.getElementById('kali-canvas');
  if (!canvas) return;
  var ctx = canvas.getContext('2d');
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var w = 0, h = 0, dpr = 1, stars = [];

  function makeStars() {
    var n = Math.floor((w * h) / 9000);
    stars = [];
    for (var i = 0; i < n; i++) {
      stars.push({ x: Math.random()*w, y: Math.random()*h, r: Math.random()*1.3+0.25, tw: Math.random()*Math.PI*2, sp: 0.008+Math.random()*0.03 });
    }
  }
  function resize() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    w = window.innerWidth; h = window.innerHeight;
    canvas.width = w*dpr; canvas.height = h*dpr;
    canvas.style.width = w+'px'; canvas.style.height = h+'px';
    ctx.setTransform(dpr,0,0,dpr,0,0);
    makeStars();
  }
  var target = {x:0,y:0}, head = {x:0,y:0,vx:0,vy:0}, trail = [], TRAIL = 70;
  var SPRING = 0.003, FRICTION = 0.95, SWIRL = 0.0001;
  window.addEventListener('pointermove', function(e){ target.x=e.clientX; target.y=e.clientY; }, {passive:true});
  function update() {
    var dx = target.x-head.x, dy = target.y-head.y;
    head.vx += dx*SPRING - dy*SWIRL; head.vy += dy*SPRING + dx*SWIRL;
    head.vx *= FRICTION; head.vy *= FRICTION;
    head.x += head.vx; head.y += head.vy;
    trail.unshift({x:head.x,y:head.y}); if (trail.length>TRAIL) trail.pop();
  }
  function draw() {
    ctx.clearRect(0,0,w,h);
    ctx.globalCompositeOperation = 'lighter';
    for (var i=0;i<stars.length;i++){
      var s=stars[i]; s.tw+=s.sp; var t=0.5+0.5*Math.sin(s.tw); t=t*t*t;
      var a=0.04+0.5*t;
      ctx.fillStyle='rgba(228,228,242,'+a+')';
      ctx.beginPath(); ctx.arc(s.x,s.y,s.r,0,Math.PI*2); ctx.fill();
      if (t>0.86){ var g=(t-0.86)/0.14; var len=s.r*(2.2+g*3);
        ctx.strokeStyle='rgba(245,245,255,'+(g*0.32)+')'; ctx.lineWidth=0.6;
        ctx.beginPath(); ctx.moveTo(s.x-len,s.y); ctx.lineTo(s.x+len,s.y); ctx.moveTo(s.x,s.y-len); ctx.lineTo(s.x,s.y+len); ctx.stroke();
      }
    }
    ctx.globalCompositeOperation='source-over';
    ctx.globalCompositeOperation='lighter'; ctx.lineCap='round';
    for (var j=0;j<trail.length-1;j++){
      var p=trail[j], q=trail[j+1]; var f=1-j/trail.length;
      ctx.lineWidth=f*4.5+0.4;
      var gg=Math.round(95+130*f), bb=Math.round(120+95*f);
      ctx.strokeStyle='rgba(255,'+gg+','+bb+','+(f*0.9)+')';
      ctx.beginPath(); ctx.moveTo(p.x,p.y); ctx.lineTo(q.x,q.y); ctx.stroke();
    }
    var hd=trail[0];
    if (hd){ var grd=ctx.createRadialGradient(hd.x,hd.y,0,hd.x,hd.y,18);
      grd.addColorStop(0,'rgba(255,255,255,0.95)'); grd.addColorStop(0.3,'rgba(255,200,220,0.7)'); grd.addColorStop(1,'rgba(255,80,120,0)');
      ctx.fillStyle=grd; ctx.beginPath(); ctx.arc(hd.x,hd.y,18,0,Math.PI*2); ctx.fill();
    }
    ctx.globalCompositeOperation='source-over';
  }
  function tick(){ if(!reduce) update(); draw(); requestAnimationFrame(tick); }
  window.addEventListener('resize', resize);
  resize();
  target.x=w*0.5; target.y=h*0.5; head.x=-w*0.6; head.y=-h*0.5;
  tick();
})();

/* nav extension styling — wrap the ".ext" of each header menu title in a smaller,
   dimmer span so the shop nav matches ihatekali.com (home.html, sounds.exe, ...) */
(function () {
  var mo = null;
  function wrapExt() {
    var links = document.querySelectorAll('.menu-list__link, .menu-list__link-title, .header-menu a, header-component a');
    for (var i = 0; i < links.length; i++) {
      var el = links[i];
      if (el.closest && el.closest('.header-logo')) continue;
      var host = el;
      var titleSpan = el.querySelector ? el.querySelector('.menu-list__link-title') : null;
      if (titleSpan && titleSpan.children.length === 0) host = titleSpan;
      if (host.children.length !== 0) continue;
      var t = host.textContent.trim();
      var m = t.match(/^(.*\S)(\.[a-z0-9]{1,5})$/i);
      if (!m) continue;
      host.textContent = m[1];
      var span = document.createElement('span');
      span.className = 'kali-ext';
      span.textContent = m[2];
      host.appendChild(span);
    }
  }
  function run() {
    if (mo) mo.disconnect();
    try { wrapExt(); } catch (e) {}
    if (mo) { try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {} }
  }
  function init() {
    try { mo = new MutationObserver(function () { run(); }); } catch (e) { mo = null; }
    run();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* top-of-screen dark fade (vignette) to match ihatekali.com */
(function () {
  function add() {
    if (document.getElementById('kali-topfade')) return;
    var d = document.createElement('div');
    d.id = 'kali-topfade';
    d.setAttribute('aria-hidden', 'true');
    (document.body || document.documentElement).appendChild(d);
  }
  if (document.body) add();
  else document.addEventListener('DOMContentLoaded', add);
})();
